import Vue from "vue";
import Vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
import vuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import FormGroup from "@/components/FormGroup";
import CustomButton from "@/components/CustomButton";
import GoogleMaps from "@/components/GoogleMaps";
import LocaleSelect from "@/components/LocaleSelect";
import CurrentPath from "./components/CurrentPath";
import GlobalToolbar from "@/components/GlobalToolbar";
import NewImageUpload from "@/components/NewImageUpload";
import multiImageUpload from "@/components/multiImageUpload";
import GlobalImagePreview from "@/components/GlobalImagePreview";
import NoData from "@/components/NoData";
import TableComponent from "@/components/TableComponent";
import GlobalToggleFilter from "@/components/GlobalToggleFilter";
import GlobalSearchFilter from "@/components/GlobalSearchFilter";
import ToggleService from "@/components/ToggleService";
import WrappingTable from "@/components/WrappingTable";
import { SweetAlert } from "@/helpers/mixins/SweetAlert.js";
import VueSweetalert2 from "vue-sweetalert2";
import { messages } from "@/lang";
import LoaderComponent from "@/components/LoaderComponent";
import "./directives";
Vue.mixin(SweetAlert);
Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.use(VueGoogleMaps, {
  load: {
    // key: "AIzaSyBPocaJkDl6MtFaT4MF4C4saWVOiV1CJBs",
    // key: process.env.GOOGLE_MAP_API_KEY,
    libraries: "places"
  }
});
Vue.use(vuelidateErrorExtractor, {
  messages,
  i18n: "validation"
});
Vue.component("global-toggle-filter", GlobalToggleFilter);
Vue.component("global-search-filter", GlobalSearchFilter);
Vue.component("wrapping-table", WrappingTable);

Vue.component("form-group", FormGroup);
Vue.component("formWrapper", templates.FormWrapper);
Vue.component("CustomButton", CustomButton);
Vue.component("google-maps", GoogleMaps);
Vue.component("current-path", CurrentPath);
Vue.component("locale-select", LocaleSelect);
Vue.component("global-toolbar", GlobalToolbar);
Vue.component("new-image-upload", NewImageUpload);
Vue.component("multi-image-upload", multiImageUpload);
Vue.component("global-image-preview", GlobalImagePreview);
Vue.component("NoData", NoData);
Vue.component("table-component", TableComponent);
Vue.component("loader-component", LoaderComponent);
Vue.component("toggle-service", ToggleService);
Vue.use(require("vue-moment"));

Vue.filter("truncate", function(value, strCount = 25) {
  if (!value) {
    return "";
  }

  return value.length > strCount
    ? value.substring(0, strCount) + "..."
    : value.substring(0, strCount);
});
